<template>
    <div>
        <q-score-card key="QScoreCardAverageDaysToSubmit" ref="card" title="Average Days to Submit App" api-endpoint="average_days_to_submit" :drill-down-label="null" :drill-down-route="null" card-style="recruiting" :agent-code="agentCode" :filters="filters" v-on:most_current="updateMostCurrent">
            Note: this is the average number of days it takes for an agent to submit their first app.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardAverageDaysToSubmit",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {
        updateMostCurrent: function(most_current) {
            this.$emit('most_current', most_current);
        }
    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
